// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"U2-z"};